import axios from 'axios';
import { toast } from 'react-toastify';
import { GET, polusBaseUrl, POST } from '../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../utils/dateUtils';

export function getCibilOverviewData(payload) {
    let queries = `?requestId=${getTimeStamp()}&assesseeId=${payload.assesseeOrgId}`;
    if (payload.type) queries += `&type=${payload.type}`;
    if (payload.directorId) queries += `&directorId=${payload.directorId}`;
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_CIBIL_OVERVIEW_DATA + queries,
        method: GET,
    });
}

function buildUrl(endpoint: string, params: Record<string, string>) {
    const searchParams = new URLSearchParams({
        requestId: getTimeStamp(),
        ...params,
    });
    return `${endpoint}?${searchParams.toString()}`;
}

export function getDirectorsOverviewData(payload) {
    const url = buildUrl(API_ENDPOINTS.GET_DIRECTORS_OVERVIEW_DATA, {
        orgId: payload.orgId,
        ...(payload.type && { type: payload.type }),
    });
    return axios({
        baseURL: polusBaseUrl,
        url,
        method: 'GET',
    });
}

export function getDirectorsBureauCibil(payload) {
    const url = buildUrl(API_ENDPOINTS.GET_DIRECTORS_BUREAU_CIBIL, {
        orgId: payload.orgId,
        ...(payload.type && { type: payload.type }),
    });
    return axios({
        baseURL: polusBaseUrl,
        url,
        method: 'GET',
    });
}
export const downloadData = async (data: object, responseType: any, url: string): Promise<any> => {
    return axios({
        baseURL: polusBaseUrl,
        url,
        method: POST,
        data,
        responseType,
    });
};

export async function downloadCibilNeedInfoSheet(payload) {
    try {
        const response = await downloadData(payload, 'arraybuffer', API_ENDPOINTS.DOWNLOAD_CIBIL_SHEET);
        if (response) {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/octet-stream' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Cibil_Query_${payload?.name}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        }
    } catch (error) {
        toast.error('Please try in sometime');
    }
}

export function getCreditBureauSummaryTableService(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_CREDIT_BUREAU_SUMMARY_TABLE,
        method: GET,
        params: {
            requestId: getTimeStamp(),
            ...payload,
        },
    });
}

export function getBureauEnquiryData(payload) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.GET_BUREAU_ENQUIRY_DATA,
        method: POST,
        data: payload,
    });
}

const API_ENDPOINTS = {
    GET_CREDIT_BUREAU_DATA: '/profile/assessee/overview/main',
    GET_CIBIL_OVERVIEW_DATA: '/insights/cibilOverviewData',
    GET_DIRECTORS_OVERVIEW_DATA: '/unifier/fetchDirectorOverviewList',
    GET_DIRECTORS_BUREAU_CIBIL: '/unifier/fetchCibilDirectorOverviewList',
    DOWNLOAD_CIBIL_SHEET: '/insights/generate-need-info-cibil-sheet',
    GET_CREDIT_BUREAU_SUMMARY_TABLE: '/cibil/table',
    GET_BUREAU_ENQUIRY_DATA: '/unifier/getEnquiryDetails',
};
